export function getShortStoreName(value) {
    if (value) {
      return value.split(' ', 2).map((word) => word.charAt(0).toUpperCase()).join('');
    }
    return '';
  }

export function getProperTime(string) {
  const date = new Date(string);
  const options = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  };
  return Intl.DateTimeFormat('en-US', options).format(date);
}

export function priceFormate(value) {
  // eslint-disable-next-line radix
  const number = parseInt(value);
  if (number) {
    return number.toLocaleString();
  }
  return value;
}